import React, { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "./Courses";
import "../Utilities/Footer.css";

const Footer = () => {
  return (
    <div
      className="footer"
      style={{
        left: 0,
        bottom: 0,
        height: "30%",
        width: "100%",
        textAlign: "center",
      }}
    >
      <div className="sb__footer section__padding">
        <div className="sb__footer-links">
          <div className="sb__footer-links_div">
            <h4>Contact Us </h4>
            
            <p> info@mentorg.org</p>
              <br />
          </div>
          <div className="sb__footer-links_div">
            <h4>Address : </h4> <p>Bangalore, Karnataka, India</p>
           
          </div>

          <div className="sb__footer-links_div">
            <h4>AboutUs</h4><p>Enjoy learning via interactive classes, courses, e-books, or shopping your favourites.
            
            </p>
            <a href="/employer">
              <p></p>
            </a>

            <a href="/employer">
              <p></p>
            </a>

            <a href="/employer">
              <p></p>
            </a>

            <a href="/employer">
              <p></p>
            </a>
          </div>
        </div>

        <hr></hr>

        <div className="sb__footer-below">
          <div className="sb__footer-copyright">
            <p>© {new Date().getFullYear()} All Rights Reserved.</p>
          </div>
          <div className="sb__footer-below-links">
            <a href="https://shop.mentorg.org/policies/terms-of-service">
              <div>
                <p>Terms & Conditions</p>
              </div>
            </a>
            <a href="https://shop.mentorg.org/policies/privacy-policy">
              <div>
                <p>Privacy Policy</p>
              </div>
            </a>
            <a href="https://shop.mentorg.org/policies/refund-policy">
              <div>
                <p>Refund Policy</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
